<script>
        import TablaGelesRigidos from "./GelesRigidosTabla.svelte";
        var rigido = false;
        function mostrarDiv(id){
            rigido = !rigido;

    }
</script>
<div class="row">
    <div class="col-10 col-lg-5" style="text-align: right;">
        <h3>Geles Refrigerantes Rígidos</h3>
    </div>
    <div class="col-2 col-lg-7 linea">
    </div>

</div>

<div class="row">
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/rigidoCuadrado.png" alt="Gel Rigido grande ICEMAGELES">
        </div>
    </div>
    <div class="col-6 col-lg-2">
        <div class="cards">
            <img class="card-img-top" src="img/Low/rigidoCuadradoChi.png" alt="Gel Rigido chico ICEMAGELES">
          </div>
    </div>
    <div class="col-12 col-lg-8 top-20">
        <ul>
            <li>
                Debido al material de alta densidad de su fabricación, son altamente resistentes a golpes, roturas y perforaciones, siendo esto muy efectivo a la hora de evitar la contaminación y asegurar una temperatura más uniforme a lo largo del gel
                <hr>
            </li>
            <li>
                Ambos son reutilizables, esto causa un aumento considerable de la vida útil de los mismos
                <hr>
            </li>
            <li>
                Están especialmente diseñados para el transporte que exigen una conservación de frío precisa sin modificaciones de la forma del gel
                <hr>
            </li>
            <li>
               Consultar por diferentes colores a pedido
            </li>
        </ul>
    </div>
    <div class="col-12" style="text-align:center;">
        <button class="boton-info" on:click={() => mostrarDiv("rigido")}>+Info</button>
    </div>
</div>
{#if rigido}
  <TablaGelesRigidos />
{/if}